import { apiSlice } from '../../../api/apiSlice';
import {
    GET_COACHING_EMP_SCORECARDS,
    GET_COACHING_METRIC_GOAL,
    GET_COACHING_MONTHLY_METRICS,
    GET_COACHING_SCORECARD,
    INSERT_COACHING_METRICS,
    INSERT_COACHING_SCORECARD,
    UPDATE_COACHING_METRICS,
} from '../../../constants';

export const MetricsSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getCoachingMonthlyMetrics: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month, scorecardId, scorecardVersionId } = arg;
                return {
                    url: GET_COACHING_MONTHLY_METRICS,
                    params: { employeeNumber, year, month, scorecardId, scorecardVersionId },
                };
            },
        }),
        getCoachingMetricGoal: builder.query({
            query: (arg: any) => {
                const { employeeNumber, coachingScorecardId, metricId } = arg;
                return {
                    url: GET_COACHING_METRIC_GOAL,
                    params: { employeeNumber, coachingScorecardId, metricId },
                };
            },
            providesTags: ['Coaching_Metric'],
        }),
        getCoachingScorecard: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month, scorecardId, entityTypeId, entityId } = arg;
                return {
                    url: GET_COACHING_SCORECARD,
                    params: { employeeNumber, year, month, scorecardId, entityTypeId, entityId },
                };
            },
            providesTags: ['Coaching_Metric'],
        }),
        insertCoachingScorecard: builder.mutation({
            query: (arg: any) => ({
                url: INSERT_COACHING_SCORECARD,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Coaching_Metric','Coaching','Activity', 'coachingInsightHistory'],
        }),
        insertCoachingMetrics: builder.mutation({
            query: (arg: any) => ({
                url: INSERT_COACHING_METRICS,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Coaching_Metric','Coaching','Activity', 'coachingInsightHistory'],
        }),
        updateCoachingMetrics: builder.mutation({
            query: (arg: any) => ({
                url: UPDATE_COACHING_METRICS,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Coaching_Metric','Coaching','coachingInsightHistory'],
        }),
        getCoachingEmpScorecards: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month } = arg;
                return {
                    url: GET_COACHING_EMP_SCORECARDS,
                    params: { employeenumber, year, month },
                };
            },
        }),
    }),
});

export const {
    useGetCoachingMonthlyMetricsQuery,
    useGetCoachingMetricGoalQuery,
    useGetCoachingScorecardQuery,
    useGetCoachingEmpScorecardsQuery,
    useInsertCoachingScorecardMutation,
    useInsertCoachingMetricsMutation,
    useUpdateCoachingMetricsMutation,
} = MetricsSlice;
